export default "__VITE_ASSET__CVccOji2__"